import { mergeMap, withLatestFrom } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IGetSelectorStateType } from '@cbridge-utils/reselect';
import { AdjustmentProfileAction } from '@cbridge-packages/adjustment-profile';
import { DetailsSidebarAction, detailsSidebarResourceIdSelector } from '@cbridge-packages/details-sidebar';

type IState = IGetSelectorStateType<typeof detailsSidebarResourceIdSelector>;

export const closeDetailsSidebarAfterRemoveEpic: IEpic<IState> = (action$, state$) => action$.pipe(
  isTypeOfAndGetPayload(AdjustmentProfileAction.remove.started),
  withLatestFrom(state$),
  mergeMap(([params, state]) => {
    const sidebarId = detailsSidebarResourceIdSelector(state);
    if (sidebarId === params.adjustmentId) {
      return [DetailsSidebarAction.close({ skipUnsavedChangesConfirmation: true })];
    }
    return [];
  }),
);
